<template>
    <div class="fixed-top system-message" ref="messageContainer">
        <div class="message-wrapper" v-if="message.haveContent" :class="message.messageType">
         <p class="text-sm text-bolder py-2 mb-0">{{ message.messageText }}</p>
        </div>
    </div>
</template>
    
<script>

import { GET_MESSAGE, SET_MESSAGE } from "@/store/sysMessage/const"
export default {
    name: "SysMess",
    data() {
        return {
            isMounted: false
        }
    },
    methods: {
        deleteMessage: function () {
            const container = this.$refs.messageContainer,
                self = this;
            setTimeout(() => {
                container.classList.remove('show');
                self.$store.commit(`sysMessage/${SET_MESSAGE}`, { 'init': true, 'haveContent': false, 'messageText': "", 'messageType': 'info' });
            }, "8000");
        }
    },
    computed: {
        message() {
            let message = this.$store.getters[`sysMessage/${GET_MESSAGE}`];
            if (message.haveContent && this.isMounted) {
                const container = this.$refs.messageContainer;
                container.classList.add('show')
                this.deleteMessage();
                return message;

            } else {
                return { 'haveContent': false, 'messageText': "", 'messageType': 'info' }
            }
        }
    },
    mounted() {
        this.isMounted = true;
    }
}
</script>
<style scoped>
.system-message {
    text-align: center;
    transition: .6s;
    max-height: 0;
}

.system-message.show {
    max-height: 50px;
}

.system-message .success {
    background-color: green;
}

.system-message .info {
    background-color: indigo
}

.system-message .error {
    background-color: #EA1E28;
}

.system-message .info p, .system-message .error  p, .system-message .success p {
    color: white
}
</style>